import type { SVGProps } from 'react';

const SvgTooltipFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 10.6982C11.5031 10.6984 11.0996 11.1017 11.0996 11.5986V16.0986C11.0998 16.5954 11.5032 16.9989 12 16.999C12.4969 16.999 12.9002 16.5955 12.9004 16.0986V11.5986C12.9004 11.1016 12.4971 10.6982 12 10.6982ZM12 7.09863C11.4478 7.09874 11 7.54641 11 8.09863C11.0002 8.65067 11.4479 9.09853 12 9.09863C12.5522 9.09863 12.9998 8.65074 13 8.09863C13 7.54635 12.5523 7.09863 12 7.09863Z'
      fill='currentColor'
    />
  </svg>
);
export default SvgTooltipFilled;
